import React, { Component, lazy, Suspense } from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import secureStorage from "../config/encrypt";

const Header = lazy(() => import("../view/common/Header"));
const Footer = lazy(() => import("../view/common/Footer"));
const Login = lazy(() => import("../view/user/Login"));
const LoginOtp = lazy(() => import("../view/user/LoginOtp"));
const PageNotFound = lazy(() => import("../view/notfound/PageNotFound"));

// Routes for Authorized access Only
const PerformanceReport = lazy(() => import("../view/performance/PerformanceReport"));
const PendingPaymentReport = lazy(() => import("../view/pending-payment/PaymentReport"));
const LoanDetailView = lazy(() => import("../view/pending-payment/LoanDetailView"));

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const loginResponse = secureStorage.getItem("authUserInfo");
  const isAuthenticated = loginResponse && Object.keys(loginResponse).length > 0;
  
  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

class CustomRouter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ht: 500,
      user_data: {}
    };
  }

  static getDerivedStateFromProps = (nextProps, state) => {
    const updatedProps = {};
    if (nextProps.user_data != state.user_data) {
      updatedProps["user_data"] = nextProps.user_data;
    }
    return updatedProps;
  };

  componentDidMount = async () => {
    this.setState({ ht: window.innerHeight - 107 });
    window.addEventListener("resize", () => {
      this.setState({ ht: window.innerHeight - 107 });
    }, false);
  }

  render() {
    const loginResponse = secureStorage.getItem("authUserInfo");
    const isAuthenticated = loginResponse && Object.keys(loginResponse).length > 0;
    
    return (
      <Router>
        <Suspense fallback={<div className="loader is-active">Loading...</div>}>
          {isAuthenticated ? <Header /> : null}
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/logout" element={<LoginOtp />} />
            
            {/* Protected Routes - only accessible when logged in */}
            <Route 
              path="/report/:report_type" 
              element={
                <ProtectedRoute>
                  <PerformanceReport/>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/pending-payment-report" 
              element={
                <ProtectedRoute>
                  <PendingPaymentReport/>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/pending-payment-report/details/:query" 
              element={
                <ProtectedRoute>
                  <LoanDetailView/>
                </ProtectedRoute>
              } 
            />
            
            {/* 404 Page */}
            <Route path='*' element={<PageNotFound />} />
          </Routes>
          {isAuthenticated ? <Footer /> : null}
        </Suspense>
      </Router>
    );
  }
}

const mapStateToProps = ({ user }) => {
  return {
    loggedIn: user.loggedIn,
    user_data: user.user_data
  };
};

export default connect(mapStateToProps, null)(CustomRouter);